import React, { useState } from "react";
import PropTypes from "prop-types";

const TextArea = ({
  placeholder = "",
  label = "",
  startIcon,
  endIcon,
  isFullWidth = false,
  onEndIconClick,
  infoIconAsEnd = false,
  infoText = "",
  rows = 4,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const baseClasses = "flex items-center px-3 py-3 border rounded-md text-sm";
  const activeClasses = isFocused
    ? "border-agPrimary shadow-outline-agPrimary"
    : "border-agGray";
  const widthClass = isFullWidth ? "w-full" : "w-auto";
  const textAreaBaseClasses =
    "flex-1 focus:outline-none bg-transparent text-agBlack resize-none";
  const tooltipPosition =
    label || infoIconAsEnd ? "top-12 right-0" : "top-2 right-0";

  return (
    <div className={`relative flex flex-col ${widthClass} mb-4`}>
      {label && (
        <div className="flex justify-between items-center mb-1">
          <label className="text-sm font-medium text-agBlack">{label}</label>
          {!infoIconAsEnd && infoText && (
            <span
              className="material-icons-round text-agLightGray text-lg cursor-pointer"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              info
            </span>
          )}
        </div>
      )}
      <div className={`flex items-start ${baseClasses} ${activeClasses}`}>
        {startIcon && (
          <span className="material-icons-round mr-2 text-agPrimaryLight">
            {startIcon}
          </span>
        )}
        <textarea
          placeholder={placeholder}
          rows={rows}
          className={textAreaBaseClasses}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...props}
        />
        {endIcon && (
          <span
            className="material-icons-round ml-2 cursor-pointer text-agPrimaryLight"
            onClick={onEndIconClick}
          >
            {endIcon}
          </span>
        )}
        {infoIconAsEnd && infoText && (
          <span
            className="material-icons-round ml-2 cursor-pointer text-agLightGray text-lg"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            info
          </span>
        )}
      </div>
      {showTooltip && (
        <div
          className={`absolute bg-white rounded-md tooltip-card p-3 text-xs text-agLightGray  w-64 z-10 ${tooltipPosition}`}
        >
          {infoText}
        </div>
      )}
    </div>
  );
};

TextArea.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  isFullWidth: PropTypes.bool,
  onEndIconClick: PropTypes.func,
  infoText: PropTypes.string,
  rows: PropTypes.number,
};

export default TextArea;
